import './App.css';
import LoginCard from './login-card/LoginCard';

function App() {
  return (
    <div className="App">
      <LoginCard />
    </div>
  );
}

export default App;
